import { combineReducers } from 'redux';
import mixcloudPodcasts from './MixcloudPodcastReducer';
import { simplecastPodcasts, currentPodcastShow } from './SimplecastPodcastsReducer';

const podcasts = combineReducers({
    simplecastPodcasts,
    currentPodcastShow,
    mixcloudPodcasts,
});

export default podcasts;
